module.exports = __webpack_public_path__ + "static/media/Diamond in the Rough.edbf6057.jpg";